import { LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { FAQBot } from "@/components/FAQBot";

export function AppShell({ children, title, subtitle, right }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 bg-grain">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-slate-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <button
            data-testid="brand-home-btn"
            onClick={() => nav("/")}
            className="flex items-center gap-3 group py-1"
          >
            <img
              src="/brand/koi-logo.png"
              alt="KOI The School Doctor"
              className="h-14 w-auto group-hover:scale-[1.03] transition-transform"
            />
            <div className="text-left leading-tight hidden sm:block border-l border-slate-200 pl-3">
              <div className="text-[11px] uppercase tracking-[0.22em] text-sky-600 font-bold">The School Doctor</div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500 font-semibold mt-0.5">Health Report Card</div>
            </div>
          </button>
          <div className="flex items-center gap-3">
            <a
              data-testid="nav-about-koi"
              href="https://agreeable-stone-097ad4d00.3.azurestaticapps.net/"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] font-bold text-sky-700 hover:text-sky-900 border border-sky-200 hover:border-sky-400 bg-sky-50/60 hover:bg-sky-50 rounded-full px-3 py-1.5 transition-colors no-print"
            >
              About KOI <ExternalLink className="w-3 h-3" />
            </a>
            {user && (
              <div className="hidden sm:flex items-center gap-2 pr-2">
                <div className="text-right leading-tight">
                  <div className="text-xs uppercase tracking-widest text-slate-400">{user.role}</div>
                  <div className="text-sm font-semibold text-slate-800" data-testid="header-username">{user.name}</div>
                </div>
              </div>
            )}
            {user && (
              <Button
                data-testid="logout-btn"
                variant="ghost"
                size="sm"
                onClick={() => { logout(); nav("/login"); }}
                className="text-slate-600 hover:text-slate-900"
              >
                <LogOut className="w-4 h-4 mr-1" /> Logout
              </Button>
            )}
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {(title || subtitle || right) && (
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 sm:mb-10">
            <div>
              {subtitle && <div className="text-xs uppercase tracking-[0.2em] font-bold text-sky-600 mb-2">{subtitle}</div>}
              {title && <h1 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 tracking-tight">{title}</h1>}
            </div>
            {right}
          </div>
        )}
        {children}
      </main>

      <footer className="border-t border-slate-200 mt-16 py-6 text-center text-xs text-slate-500">
        Preventive Healthcare through Screening in School · <span className="font-semibold text-slate-700">KOI &mdash; The School Doctor</span>
      </footer>
      <FAQBot />
    </div>
  );
}
